/* eslint-disable */

import React, { useState, useEffect } from 'react';
import Test from '../assets/images/test.png';
import '../assets/css/Testimonial.css';

const testimonials = [
  {
    name: 'Yemi',
    age: 19,
    image: Test,
    quote: "Choosing a course to learn was almost overwhelming, so many options to choose from. Motivar helped make the process seamless. I totally love the course i am currently taking"
  },
  {
    name: 'Ada',
    age: 22,
    image: Test,
    quote: "I found the perfect course for my career switch. The recommendations were spot on and the process was easy."
  },
  {
    name: 'Sam',
    age: 25,
    image: Test,
    quote: "Motivar made it easy to connect with sponsors and get the help I needed to pay for my course."
  }
];

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => {
      const isFirstSlide = prevIndex === 0;
      return isFirstSlide ? testimonials.length - 1 : prevIndex - 1;
    });
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => {
      const isLastSlide = prevIndex === testimonials.length - 1;
      return isLastSlide ? 0 : prevIndex + 1;
    });
  };

  useEffect(() => {
    const timer = setInterval(goToNext, 5000);
    return () => clearInterval(timer);
  }, []);

  const { name, age, image, quote } = testimonials[currentIndex];

  return (
    <div className="testimonial-container">
      {/* Left Arrow */}
      <button className="arrow-btn left-arrow" onClick={goToPrevious}>
        &lt;
      </button>

      {/* Main Testimonial Card — quote first so the name sits below and the text gets the width */}
      <div className="testimonial-card">
        <p className="testimonial-quote">"{quote}"</p>
        <div className="testimonial-author-info">
          <p className="testimonial-author">{name}, {age}</p>
        </div>
      </div>

      {/* Right Arrow */}
      <button className="arrow-btn right-arrow" onClick={goToNext}>
        &gt;
      </button>
    </div>
  );
};

export default TestimonialCarousel;